import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d2ef30a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer"
}, null, -1));
const _hoisted_2 = {
  class: "down-div"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, [/*#__PURE__*/_createElementVNode("div", null, "App独享高清加速，永久免费"), /*#__PURE__*/_createElementVNode("div", null, "看片更流畅，海量高清影片抢先看")], -1));
const _hoisted_6 = {
  class: "down-div"
};
const _hoisted_7 = {
  class: "left"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, [/*#__PURE__*/_createElementVNode("div", null, "海角TV"), /*#__PURE__*/_createElementVNode("div", null, "App独享超高清加速，永久免费")], -1));
import { onMounted, onUnmounted, ref, watch, nextTick } from "vue";
import { store } from "../utils/store";
import { useRoute } from 'vue-router';
import { judgeClient, isH5, downloadApp as goDownloadApp } from '@/utils';
import { channelCode } from '@/js/channel';
import { X } from '../utils/request';
export default {
  __name: 'Footer',
  setup(__props) {
    const route = useRoute();
    const showDownload = ref(false);
    const showDownload2 = ref(false);
    const downAppRef = ref(null);
    const downAppRef2 = ref(null);
    const enableDownload = ref(false);
    const openWebsite = () => {
      window.open(store.config.website);
    };
    // downloadApp
    const downloadApp = () => {
      const iosArr = (store.config.ios_download_urls || '').split(',').filter(Boolean);
      const androidArr = (store.config.android_download_urls || '').split(',').filter(Boolean);
      goDownloadApp(iosArr, androidArr);
    };
    const handleScroll = () => {
      const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (top > 5) {
        showDownload.value = false;
      } else {
        showDownload.value = enableDownload.value;
      }
      if (top > 5) {
        showDownload2.value = enableDownload.value;
      } else {
        showDownload2.value = false;
      }
    };
    onMounted(() => {
      setTimeout(() => {
        const client = judgeClient();
        var data = OpenInstall.parseUrlParams(); ///openinstall-{appKey}.js中提供的api，解析当前网页url中的查询参数并对data进行赋值
        new OpenInstall({
          //初始化方法，与openinstall服务器交互，应尽早调用
          appKey: "g648ln",
          //appKey为openinstall为应用分配的唯一id（必须传入）
          channelCode: data.channelCode || X.Xchanne || channelCode,
          onready: function () {
            //初始化成功回调方法。当初始化完成后，会自动进入
            // this.schemeWakeup();//尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
            var m = this,
              button = document.getElementById("downAppBtn"),
              button2 = document.getElementById("downAppBtn2"); //为button对象绑定对应id的元素
            if (button) button.onclick = function () {
              //对应button的点击事件
              // if (client === 'IOS') {
              //   downloadApp();
              //   return;
              // }
              m.wakeupOrInstall({
                data: {
                  url: window.location.href
                },
                channelCode: data.channelCode || X.Xchanne || channelCode
              }); //此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
              return false;
            };
            if (button2) button2.onclick = function () {
              // if (client === 'IOS') {
              //   downloadApp();
              //   return;
              // }
              m.wakeupOrInstall({
                data: {
                  url: window.location.href
                },
                channelCode: data.channelCode || X.Xchanne || channelCode
              }); //此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
              return false;
            };
          }
        }, data); //初始化时传入data，作为一键拉起/App传参安装时候的参数

        // 根据平台使用对应下载地址，仅当存在对应地址且为 H5 时展示
        const list = client === 'IOS' ? store.config.ios_download_urls || '' : client === 'Android' ? store.config.android_download_urls || '' : '';
        const hasUrls = String(list).split(',').filter(Boolean).length > 0;
        // console.log(
        //   'list', list);

        enableDownload.value = hasUrls && isH5();
        handleScroll();
      }, 1000);
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    watch(showDownload, async visible => {
      store.setDownloadBarVisible(visible);
      if (visible) {
        await nextTick();
        const h = downAppRef.value?.getBoundingClientRect?.().height || 0;
        store.setDownloadBarHeight(h);
      }
    });
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _withDirectives(_createElementVNode("div", {
        class: "down-app2",
        ref_key: "downAppRef2",
        ref: downAppRef2
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "logo-img",
        src: _unref(store).config.favicon_ico,
        alt: ""
      }, null, 8, _hoisted_4), _hoisted_5]), _createElementVNode("div", null, [_createVNode(_component_van_button, {
        id: "downAppBtn2",
        type: "primary",
        size: "small",
        style: {
          "border-radius": "8px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("立即下载")]),
        _: 1
      })])])], 512), [[_vShow, showDownload2.value]]), _withDirectives(_createElementVNode("div", {
        class: "down-app",
        ref_key: "downAppRef",
        ref: downAppRef
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_icon, {
        name: "cross",
        class: "popup-close-icon",
        onClick: _cache[0] || (_cache[0] = $event => {
          showDownload.value = false;
          showDownload2.value = true;
        })
      }), _createElementVNode("img", {
        class: "logo-img",
        src: _unref(store).config.favicon_ico,
        alt: ""
      }, null, 8, _hoisted_8), _hoisted_9]), _createElementVNode("div", null, [_createVNode(_component_van_button, {
        id: "downAppBtn",
        type: "primary",
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode("立即下载")]),
        _: 1
      })])])], 512), [[_vShow, showDownload.value]])], 64);
    };
  }
};